<template>
    <div class="inner">
        <div v-if="showCreatedAccountInfo" class="exclamation exclamation--green">
            <span class="exclamation__text exclamation__text--green">
                {{ $t('ACCOUNT_WAS_NOT_ACTIVATED_2') }}
                <router-link to="wyslij-kod-aktywacyjny" class="activation-code-link">
                    {{ $t('CLICK_HERE') }}
                </router-link>
                {{ $t('TO_GENERATE_NEW_LINK') }}
            </span>
        </div>
        <div class="login-form-container">
            <app-my-login-form></app-my-login-form>
            <app-my-registry-form @accountCreated="showCreatedAccountInfo = true"></app-my-registry-form>
        </div>
    </div>
</template>

<script>
import myLoginForm from './login.vue';
import myRegistryLoginForm from './registry.vue';

export default {
    components: {
        appMyLoginForm: myLoginForm,
        appMyRegistryForm: myRegistryLoginForm,
    },
    data() {
        return {
            showCreatedAccountInfo: false,
        };
    },
};
</script>

<style lang="scss">
.inner {
    max-width: 1170px;
    width: 92%;
    margin: 0 auto;
}

.login-form-container {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    border: 1px solid #ede8e4;
}

.login-form-container__element,
.login-form-container__element--right,
.login-form-container__element--left {
    padding: 2.187rem 3.125rem 2.187rem 3.125rem;
    padding-bottom: 1.125rem;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
}

.login-form-container {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    border: 1px solid #ede8e4;
}

.login-form-container__element,
.login-form-container__element--right,
.login-form-container__element--left {
    padding: 2.187rem 3.125rem 2.187rem 3.125rem;
    padding-bottom: 1.125rem;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
}

.login-form-container__element--right {
    background-color: #f9f8f6;
    border-left: 1px solid #ede8e4;
}

@media only screen and (max-width: 767px) {
    .login-form-container__element,
    .login-form-container__element--right,
    .login-form-container__element--left {
        padding: 1.25rem 1.25rem 1.25rem 1.25rem;
        width: 100%;
    }
}

@media only screen and (max-width: 767px) {
    .login-form-container {
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
}

.-padding-bottom {
    padding-bottom: 3.125rem;
}

.log-reg-form__heading {
    font-weight: 700;
    font-size: 1.875rem;
    white-space: nowrap;
}

@media only screen and (max-width: 767px) {
    .log-reg-form__heading {
        white-space: normal;
    }
}

.log-reg-form__list {
    width: 100%;
    margin-top: 1.25rem;
}

.log-reg-form__list--remind {
    text-align: right;
    margin-top: 0.312rem;
}

.log-reg-form__list--check {
    margin-top: 0.75rem;
}

.log-reg-form__list--agreements {
    margin-top: 1.25rem;
}

.log-reg-form__list--agreement {
    font-size: 0.75rem;
    color: #706c69;
}

.log-reg-form__list--save-password {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 1.25rem;
    padding-left: 1.875rem;
    position: relative;
    font-size: 0.75rem;
}

.log-reg-form__list--save-password:before {
    content: '';
    width: 1.25rem;
    height: 1.25rem;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    background: url('../../../assets/images/excl.svg') no-repeat;
    background-size: cover;
    background-position: center;
}

.send-mail-page .validation-texts-container {
    width: 100%;
}

.send-mail-page.topic-chose {
    margin-top: 10.937rem;
}

@media only screen and (max-width: 767px) {
    .send-mail-page.topic-chose {
        margin-top: 105px;
    }
}

.validation-texts-container {
    padding: 0;
    -webkit-transition: padding 0.25s ease-in-out;
    transition: padding 0.25s ease-in-out;
    position: relative;
    min-width: 25rem;
}

.validation-texts-container.-bigger-margin {
    margin-top: 0.437rem;
}

.validation-texts-container:before {
    content: '';
    background: url('../../../assets/images/excl-red.svg') no-repeat;
    background-size: cover;
    background-position: center;
    width: 1.875rem;
    height: 1.875rem;
    display: block;
    opacity: 0;
    visibility: hidden;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
}

.validation-texts-container.show {
    padding: 1.25rem 0rem 1.25rem 0rem;
}

.validation-texts-container.show.-margin-bottom {
    margin-bottom: 0.625rem;
}

.validation-texts-container__text {
    color: red;
    font-weight: 800;
    opacity: 0;
    visibility: hidden;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 2.5rem;
}

@media only screen and (max-width: 767px) {
    .validation-texts-container__text {
        font-size: 0.75rem;
    }
}

.validation-texts-container__text--small {
    font-size: 0.875rem;
}

@media only screen and (max-width: 767px) {
    .validation-texts-container__text--small {
        font-size: 0.75rem;
    }
}

.validation-texts-container__text br {
    display: none;
}

@media only screen and (max-width: 767px) {
    .validation-texts-container__text br {
        display: block;
    }
}

.validation-texts-container.-white-text {
    border: 0 solid red;
}

.validation-texts-container.-white-text .validation-texts-container__text {
    color: #fff;
}

.validation-texts-container.-white-text:before {
    background: url('../../../assets/images/excl-white2.svg') no-repeat;
    background-size: cover;
    background-position: center;
}

.validation-texts-container.-white-text.show {
    margin-bottom: 0.625rem;
}

.validation-texts-container.show-required:before {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.validation-texts-container.show-required .validation-texts-container__text--required-fields {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
    border-width: 2px;
}

.validation-texts-container.show-email:before {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.validation-texts-container.show-email .validation-texts-container__text--wrong-login-data {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.validation-texts-container.show-inactive:before {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.validation-texts-container.show-inactive .validation-texts-container__text--not-activated {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.validation-texts-container.show-code:before {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.validation-texts-container.show-code .validation-texts-container__text--wrong-code {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.validation-texts-container.-summary-validation {
    margin-left: 4.375rem;
}

.validation-texts-container.-summary-validation .validation-texts-container__text {
    font-size: 0.812rem;
}

#mail-modal .validation-texts-container {
    margin-bottom: 0.625rem;
}

.log-reg-form__input {
    width: 100%;
}

.-grey-input {
    border: 1px solid #ede8e4;
    color: #333333;
}

.-grey-input::-webkit-input-placeholder {
    font-weight: 600;
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
    font-size: 1rem;
    color: #706c69;
}

.-grey-input:-moz-placeholder {
    font-weight: 600;
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
    font-size: 1rem;
    color: #706c69;
}

.-grey-input::-moz-placeholder {
    font-weight: 600;
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
    font-size: 1rem;
    color: #706c69;
}

.-grey-input:-ms-input-placeholder {
    font-weight: 600;
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
    font-size: 1rem;
    color: #706c69;
}

.log-reg-form__remind-password {
    font-weight: 400;
    text-decoration: underline;
    font-size: 0.875rem;
    color: #cf004a;
}

.log-reg-form__remind-password:hover {
    text-decoration: none;
}

@media only screen and (max-width: 767px) {
    .modal {
        width: 100%;
        max-width: none;
        padding: 2.5rem 2.5rem 2.5rem 2.5rem;
        overflow-y: auto;
        -webkit-transform: none;
        transform: none;
        margin: 1.25rem auto;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .modal .buttons-container__button {
        display: block;
        margin: 0;
        margin-bottom: 1.25rem;
        width: 100%;
    }

    .modal .buttons-container__button:last-child {
        margin-bottom: 0;
    }
}

.buttons-container__button {
    margin-right: 1.25rem;
    line-height: 3.125rem;
    display: inline-block;
    font-weight: 700;
    font-size: 1.125rem;
    border-radius: 6.25rem;
    text-align: center;
    padding: 0 1.875rem;
    outline: none;
    white-space: nowrap;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: background-color 0.25s ease-in-out, color 0.25s ease-in-out, border-color 0.25s ease-in-out;
    transition: background-color 0.25s ease-in-out, color 0.25s ease-in-out, border-color 0.25s ease-in-out;
    font-family: 'Ek Mukta', sans-serif;
}

.buttons-container__button:last-child {
    margin-right: 0;
}

@media only screen and (max-width: 767px) {
    .slide-content {
        width: 100%;
        max-width: 100%;
        text-align: center;
    }

    .slide-content .buttons-container__button {
        margin: 0;
        margin-top: 1.25rem;
        display: block;
    }
}

.promotion-code__container .buttons-container__button {
    margin: 0;
}

.text-input {
    border-radius: 6.25rem;
    padding: 0rem 1.312rem 0rem 1.312rem;
    padding-top: 0.187rem;
    outline: none;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 1rem;
    font-weight: 600;
    height: 3.375rem;
    -webkit-transition: border 0.25s ease-in-out, box-shadow 0.25s ease-in-out;
    -webkit-transition: border 0.25s ease-in-out, -webkit-box-shadow 0.25s ease-in-out;
    transition: border 0.25s ease-in-out, -webkit-box-shadow 0.25s ease-in-out;
    transition: border 0.25s ease-in-out, box-shadow 0.25s ease-in-out;
    transition: border 0.25s ease-in-out, box-shadow 0.25s ease-in-out, -webkit-box-shadow 0.25s ease-in-out;
    background-color: white;
}

.text-input.validate {
    border: 2px solid red !important;
}

.text-input.validate-red {
    -webkit-box-shadow: 10px 10px 50px 20px pink inset;
    box-shadow: 10px 10px 50px 20px pink inset;
    border: 3px solid #fff;
}

.text-input::-webkit-input-placeholder {
    font-family: 'Ek Mukta', sans-serif;
    font-size: 1rem;
}

.text-input:-moz-placeholder {
    font-family: 'Ek Mukta', sans-serif;
    font-size: 1rem;
}

.text-input::-moz-placeholder {
    font-family: 'Ek Mukta', sans-serif;
    font-size: 1rem;
}

.text-input:-ms-input-placeholder {
    font-family: 'Ek Mukta', sans-serif;
    font-size: 1rem;
}

.text-input.-disabled-input {
    background-color: #f9f8f6;
    width: 100%;
}

.checkbox {
    padding-left: 2.187rem;
    position: relative;
    display: block;
    cursor: pointer;
    text-align: left;
}

.checkbox__check-input {
    display: none;
    outline: none;
}

.checkbox__check-input:checked + .checkbox__check {
    border: none;
}

.checkbox__check-input:checked + .checkbox__check:before {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
}

.checkbox--grey .checkbox__text {
    color: #706c69;
}

.checkbox__check {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: border 0.25s ease-in-out;
    transition: border 0.25s ease-in-out;
    border-radius: 0.25rem;
    background: transparent;
    height: 1.25rem;
    width: 1.25rem;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: white;
}

.checkbox__check:before {
    opacity: 0;
    visibility: hidden;
    -webkit-transition: opacity 0.25s ease-in-out, visibility 0.25s;
    transition: opacity 0.25s ease-in-out, visibility 0.25s;
    content: '';
    width: 100%;
    height: 100%;
    background: url('../../../assets/images/checked.png') no-repeat;
    background-size: cover;
    background-position: center;
}

.checkbox__text {
    color: #fff;
    font-size: 0.875rem;
    font-weight: 400;
}

.checkbox__star {
    color: #cf004a;
    font-size: 0.875rem;
    vertical-align: top;
}

.checkbox.-checkbox-long .checkbox__check {
    top: 0;
    -webkit-transform: none;
    transform: none;
}

.checkbox.validate .checkbox__check {
    border: 2px solid red !important;
}

.-grey-border-checkbox {
    border: 1px solid #cdc9c6;
}

.-black-checkbox-text {
    color: #333333;
    font-weight: 700;
}

.log-reg-form__checkbox-text {
    font-size: 0.875rem;
    font-weight: 400;
}

@media only screen and (max-width: 767px) {
    .send-mail-info__list {
        margin-bottom: 0.625rem;
        white-space: nowrap;
    }

    .send-mail-info__list:last-child {
        margin-bottom: 0;
    }

    .send-mail-info__list .log-reg-form__checkbox-text {
        font-size: 0.812rem;
    }
}

.log-reg-form__link,
.log-reg-form__link--margin {
    color: #cf004a;
    text-decoration: underline;
}

.log-reg-form__link:hover,
.log-reg-form__link--margin:hover {
    text-decoration: none;
}

.log-reg-form__link--margin {
    margin-left: 0.625rem;
}

.-button-red {
    background-color: #cf004a;
    color: #fff;
    border: 2px solid #cf004a;
}

.-button-red:hover {
    background-color: transparent;
    color: #cf004a;
}

ol,
ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

html,
body {
    font-family: 'Ek Mukta', sans-serif;
    font-size: 16px;
    color: #333333;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

@media only screen and (max-width: 990px) {
    html,
    body {
        font-size: 12px;
    }
}

@media only screen and (max-width: 767px) {
    html,
    body {
        font-size: 13px;
    }
}

html,
body {
    overflow-x: hidden;
}

html.sticked,
body.sticked {
    overflow: hidden;
}

a:hover {
    color: #cf004a;
}

.exclamation {
    border: 1px dashed #0e9604;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 14px 10px 14px 1.25rem;
    margin-top: 12px;
    margin-bottom: 20px;
}

.exclamation__text--green {
    color: #0e9604 !important;
}

.exclamation__text {
    font-weight: 700;
    color: #333333;
    font-size: 1rem;
    line-height: 21px;
    padding-left: 2.312rem;
    position: relative;
}

@media only screen and (max-width: 990px) {
    .exclamation__text {
        line-height: 16px;
    }
}

.exclamation__text--green:before {
    background: url('../../../assets/images/check-green.svg') center no-repeat;
    background-size: cover;
}

.exclamation__text:before {
    width: 1.125rem;
    height: 1.125rem;
    background-size: cover;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    content: '';
}
</style>



// WEBPACK FOOTER //
// login-signin.vue?010429ac